import { message, Modal } from 'antd';
import { ExclamationCircleOutlined } from '@ant-design/icons';
import React from 'react';
import { request } from '../../../fetch/core';
import { api } from '../../../fetch/bussiness/api';
import dayjs from 'dayjs';
import { HttpStatusCode } from '../../../fetch/core/constant';
import qs from 'qs';
import { useSelector } from 'react-redux';
import { RootState } from '../../../redux/store';
import { analyzeLog, clstagStr } from '../../../utils/util';
import { TakeOverStatus } from '@/views/PatrolMode/types';
import { CLSTAG } from '@/utils/constant';
interface Props {
  isStoped: boolean;
  disabled: boolean;
  operatorIsSelf: boolean;
  takeOverStatus: string;
  onShowMessage: (name: string) => void;
}

const RemoveStop = (props: Props) => {
  const singleVehiclePageInfo = useSelector(
    (state: RootState) => state.singleVehiclePageInfo,
  );
  const { vehicleRealTimeInfo } = singleVehiclePageInfo;
  const { isStoped, disabled, operatorIsSelf, takeOverStatus } = props;
  const usable =
    operatorIsSelf &&
    isStoped &&
    !disabled &&
    vehicleRealTimeInfo?.vehicleState === 'EMERGENCY_STOP' &&
    takeOverStatus === TakeOverStatus.TAKEOVER;
  const sendCommand = async (path: string, data: any) => {
    const res = await request({
      method: 'POST',
      path,
      body: data,
    });
    return res;
  };

  const handleClick = () => {
    if (usable) {
      Modal.confirm({
        icon: <ExclamationCircleOutlined />,
        width: 500,
        content: (
          <div style={{ height: '60px' }}>
            <p>您是否确定解除车端按钮拍停？</p>
            <p>(备注：若指令下发后报警未解除，则该车型硬件不支持该功能)</p>
          </div>
        ),
        okText: '确认',
        cancelText: '取消',
        onOk: handleOk,
        onCancel: handleCancel,
      });
    }
  };
  const handleOk = () => {
    props.onShowMessage('removeStop');
    const query = qs.parse(window.location.search.split('?')[1]);
    const vehicleName = query && query.license;
    sendCommand(api.estop, {
      vehicleName: vehicleName,
      timeStamp: dayjs().format('YYYY-MM-DD HH:mm:ss'),
    }).then((res) => {
      if (res.code == HttpStatusCode.Success) {
        message.success('指令下发成功');
      } else {
        message.error('指令下发失败');
      }
    });

    analyzeLog('removeStop', '{}');
  };
  const handleCancel = () => {};
  return (
    <>
      <li
        className='item remove_stop'
        onClick={handleClick}
        clstag={clstagStr(CLSTAG.RemoveStop)}
      >
        {usable ? <div className='img_normal' /> : <div className='img_gray' />}
        <h3 className='operate_key'>解除拍停</h3>
      </li>
    </>
  );
};
export default React.memo(RemoveStop);
